var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"card  card-outline",class:[_vm.color ? _vm.color : 'card-primary']},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }